import script from "./ChoicesSelect.vue?vue&type=script&setup=true&lang=js"
export * from "./ChoicesSelect.vue?vue&type=script&setup=true&lang=js"

import "./ChoicesSelect.vue?vue&type=style&index=0&id=263a7c45&lang=css"

const __exports__ = script;

export default __exports__